/**
 * @generated SignedSource<<69ddec170ed360d5a287347678ded3c9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteMultipleLabelsInput = {
  ids?: ReadonlyArray<string | null> | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteMultipleLabelsMutation$variables = {
  input: DeleteMultipleLabelsInput;
};
export type deleteMultipleLabelsMutation$data = {
  readonly deleteMultipleLabels: {
    readonly deletedLabelIds: ReadonlyArray<string | null> | null;
  } | null;
};
export type deleteMultipleLabelsMutation = {
  variables: deleteMultipleLabelsMutation$variables;
  response: deleteMultipleLabelsMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteMultipleLabelsPayload",
    "kind": "LinkedField",
    "name": "deleteMultipleLabels",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedLabelIds",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteMultipleLabelsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteMultipleLabelsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f14c66a5d702542180ba38139ac1dcca",
    "id": null,
    "metadata": {},
    "name": "deleteMultipleLabelsMutation",
    "operationKind": "mutation",
    "text": "mutation deleteMultipleLabelsMutation(\n  $input: DeleteMultipleLabelsInput!\n) {\n  deleteMultipleLabels(input: $input) {\n    deletedLabelIds\n  }\n}\n"
  }
};
})();

(node as any).hash = "03e08d8ab0b2b42ec654e5b7a293a7ee";

export default node;
